// extracted by mini-css-extract-plugin
export default {"manage":"Manage_manage__pU0FF","sectionHeader":"Manage_sectionHeader__UpuCE","entityDetails":"Manage_entityDetails__tDAel","nav":"Manage_nav__aKtI5","detail":"Manage_detail__hGYQF"};